import React, {useState} from "react";
import RestRequest from "../../tool/RestRequest";
import config from "../../config";
import BasketService from "../../service/BasketService";

export default function CounterControl({product_id, count, params}) {

    const [counter, setCounter] = useState(count);

    let handleSubmit = (event) => {
        event.preventDefault();
    };

    let handlePlus = (event) => {

        BasketService.plus(product_id, counter + 1).then(result => {
            if (result.status === 200) {
                try {
                    params.setBasket(result.data.items);
                } catch (e) {
                }

                try {
                    setCounter(counter + 1);
                } catch (e) {
                }

                try {
                    params.total();
                } catch (e) {
                }
            }
        });
    };

    let handleMinus = (event) => {

        const _counter = counter - 1;

        if (_counter <= 0) {

            RestRequest.delete(config.restBasket, product_id).then(result => {

                if (result.status === 200) {
                    try {
                        params.setInBasket(false);
                    } catch (e) {
                    }
                    try {
                        params.removeItem(product_id);
                    } catch (e) {
                    }
                    try {
                        params.total();
                    } catch (e) {
                    }
                    try {
                        params.updateCounter(false);
                    } catch (e) {
                    }
                }
            });

            return false;
        }

        if (_counter <= -1) {
            return false;
        }

        setCounter(_counter);

        let postParams = new FormData();
        postParams.append('count', _counter);
        postParams.append('productId', product_id);

        RestRequest.update(config.restBasket, product_id, {
            body: postParams,
        }).then(result => {

            if (result.status === 200) {
                try {
                    params.setBasket(result.data.items);
                    params.total();
                } catch (e) {
                }
            }
        });
    };

    return <form className="basket-control-form" onSubmit={handleSubmit}>
        <button onClick={handleMinus} className="basket-control-minus" type="button">-</button>
        <input name="productId" defaultValue={product_id} type="hidden"/>
        <input name="count" value={counter} type="text" className="basket-control-counter"/>
        <button onClick={handlePlus} type="button" className="basket-control-plus">+</button>
    </form>
}